import { Icon } from "@iconify/react";
// material
import { Stack } from "@mui/material";

// ----------------------------------------------------------------------

export default function Footer() {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      spacing={1.5}
      sx={{ py: "2%" }}
    >
      <Stack>
        <p className="footer_txt">LONDON</p>
        <p className="footer_txt">ADDRESS</p>
        <p className="footer_txt">+44 444 44 444</p>
        <p className="footer_txt">HELLO@RHOOD.IO</p>
      </Stack>
      <Stack>
        <p className="footer_txt">DON'T BE AFRAID TO SAY HELLO.</p>
      </Stack>
      <Stack>
        <p className="footer_txt">
          AND WE'D LOVE FOR YOU TO FOLLOW OUR ADVENTURE.
        </p>
      </Stack>
      <Stack direction="row" spacing={{ xs: 0.5, sm: 1.5, md: 2, lg: 4 }}>
        <Icon
          icon="akar-icons:discord-fill"
          color="white"
          width="36"
          height="36"
        />
        <Icon icon="fa-brands:instagram" color="white" width="36" height="36" />
        <Icon
          icon="akar-icons:twitter-fill"
          color="white"
          width="36"
          height="36"
        />
        <Icon
          icon="simple-icons:opensea"
          color="white"
          width="36"
          height="36"
        />
      </Stack>
    </Stack>
  );
}
